module.exports = __webpack_public_path__ + "static/img/questionnaire.7fbcd93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire.png
// module id = uvkT
// module chunks = 1